import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22language-name-fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./font-files/noto-sans-jp-language-name.woff2%22,%22weight%22:%22100%20900%22,%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false}],%22variableName%22:%22japaneseNameFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'japaneseNameFont'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
